<style scoped>
	
	
	.line-box {
		display: flex; flex-direction: row; height: 60px; align-items: center;
		margin-left: 30px;
	}
	.line-name {
		width: 130px; text-align: right; padding-right: 10px;
	}
	.line-tag-box {
		display: flex; flex-direction: row;  align-items: center;
		margin-left: 30px;
	}
	.line-tag {
		width: 700px;  background-color: #f2dede; color: #b94a48; line-height: 20px; padding: 10px; border-radius: 3px;
		margin-bottom: 30px;
	}
	
	.upload-box {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	
	
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 60px;
	    height: 60px;
	    line-height: 60px;
	    text-align: center;
	  }
	  .avatar {
	    width: 60px;
	    height: 60px;
	    display: block;
	  }
</style>

<template>
	<div class="content">
		<div style="box-shadow: 1px 1px 10px #DCDCDC; height: 40px; background-color: white; display: flex; flex-direction: row; align-items: center; margin: 0 10px; padding: 5px 5px 5px 20px; border-radius: 10px;">
			<el-button icon="el-icon-refresh-right" circle  @click="getData" style="margin-right: 20px;"></el-button>
			
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>首页</el-breadcrumb-item>
			  <el-breadcrumb-item>系统设置</el-breadcrumb-item>
			  <el-breadcrumb-item>版本设置</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div style="background-color: white; margin: 10px; padding: 30px 0; border-radius: 10px;">
			<div class="line-box">
				<div class="line-name">版本号：</div>
				<el-input type="number" style="width: 720px;" v-model="config.version" placeholder="版本号" ></el-input>
			</div>
			<div class="line-box">
				<div class="line-name">更新地址：</div>
				<el-input style="width: 720px;" v-model="config.update" placeholder="更新地址"></el-input>
			</div>
			<div class="line-box">
				<div class="line-name">接口地址1：</div>
				<el-input style="width: 720px;" v-model="config.url1" placeholder="接口地址1" ></el-input>
			</div>
			<div class="line-box">
				<div class="line-name">接口地址2：</div>
				<el-input style="width: 720px;" v-model="config.url2" placeholder="接口地址2" ></el-input>
			</div>
			<div class="line-box">
				<div class="line-name">接口地址3：</div>
				<el-input style="width: 720px;" v-model="config.url3" placeholder="接口地址3"></el-input>
			</div>
			
			<div style="width: 100%; margin-top: 20px; margin-left: 170px;">
				<el-button style="width: 200px;" type="primary" @click="submit">保存配置</el-button>
				<el-button style="width: 200px;" type="danger" @click="asyncHandle">同步配置</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				config:{
					version:'',
					update:'',
					url1:'',
					url2:'',
					url3:''
				}
			}
		},
		created(){
			this.getData();
		},
		methods: {
			asyncHandle(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '同步中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.get("/System/asyncVersionConfig", {}).then(res=>{
					loading.close();
					if(res.code == 1)
					{
						_this.$message({
							 message: '同步成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
					_this.$message({
						 message: '同步失败',
						 type: 'warning',
					});
					
				});
			},
			getData(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '加载中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.get("/System/getVersionConfig", {}).then(res=>{
					loading.close();
					if(res.code == 1)
					{
						_this.config = res.data;
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
					_this.$message({
						 message: '获取订单失败，请刷新后重试',
						 type: 'warning',
					});
				});
			},
			submit(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '保存中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/System/setVersionConfig", {...this.config}).then(res=>{
					loading.close();
					if(res.code == 1)
					{
						_this.$message({
							 message: '保存成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
					loading.close();
				}).catch(err=>{
					loading.close();
					_this.$message({
						 message: '保存失败，请重试',
						 type: 'warning',
					});
				});
			},
		},
	}
</script>
